<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="section-3">
<h1>2</h1>
<p style="text-indent: 0em">Shivers of the dark overtake my heart</p>
<p style="text-indent: 0em">I can’t help being sucked into the void when it’s all I’ve learned</p>
<p style="text-indent: 0em">The colors of my days range from blue to crimson</p>
<p style="text-indent: 0em">And I cannot… I will not…bend…</p>
<p style="text-indent: 0em">To the fury</p>
<p style="text-indent: 0em">To the pain</p>
<p style="text-indent: 0em">And everything in between.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch007.vue?397cfc98